import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, Col, Form, Image, Row, Table } from 'react-bootstrap'
import Select from 'react-select'
import { ClientService } from '../../component/services/client.service';
import moment from 'moment';
import toast from 'react-hot-toast';
import TablePaginationComponent from '../../component/table/TablePagination';
import PreviewModal from '../../component/modals/Preview.modal';
import { saveAsCSV } from '../../component/helpers/csvhelper';
import { UsersCard } from '../../component/Card/Statistics.card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh, faUser } from '@fortawesome/free-solid-svg-icons';
import { count } from 'console';
import FiltersComponent, { FilterOption } from '../../component/Filters/FiltersComponent';
import InvigilatorModal from '../../component/modals/Invigilator.Modal';

export default function AttendanceReport() {
    const [shifts, setShifts] = useState<any>();
    const [selectValue, setSelectValue] = useState<any>();
    const [states, setStates] = useState<any>();
    const [zones, setZones] = useState<any>();
    const [districts, setDistricts] = useState<any>();
    const [centers, setCenters] = useState<any>();
    const [selectedStates, setSelectedStates] = useState<any>();
    const [selectedZones, setSelectedZones] = useState<any>();
    const [selectedDistricts, setSelectedDistricts] = useState<any>();
    const [selectedCenters, setSelectedCenters] = useState<any>();
    const [pageSize, setPageSize] = useState<number>(10);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalCount, setTotolCount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [studentsData, setStudentsData] = useState<any[]>([]);
    const [tobeSynced, setTobeSynced] = useState<number>(0);

    const attendanceOptions = [
        { label: "All", value: 'all' },
        { label: "Present", value: true },
        { label: "Absent", value: false },
    ];

    const [selectedAttendanceOption, setSelectedAttendanceOption] = useState<any>(attendanceOptions[0]);
    const [downloadingPresent, setDownloadingPresent] = useState<boolean>(false);
    const [downloadingAbsent, setDownloadingAbsent] = useState<boolean>(false);
    const [totalUserCount, setTotalUserCount] = useState<number>(0);
    const [presentCount, setPresentCount] = useState<number>(0);

    const [selectedFilters, setSelectedFilters] = useState<{
        states: FilterOption[];
        zones: FilterOption[];
        districts: FilterOption[];
        centers: FilterOption[];
        attendance?: any;
    }>({
        states: [],
        zones: [],
        districts: [],
        centers: [],
        attendance: attendanceOptions[0]
    });
    const [selectedOperator, setSelectedOperator] = useState<string>('');

    const handleFiltersChange = (filters: any) => {
        setSelectedFilters(filters);
    };

    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id,
                        startTime: data.startTime,
                        endTime: data.endTime
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }

    const getExceptionReport = async () => {
        if (!selectValue) {
            toast.error("Please select a shift");
            return;
        }
        let payload = {};
        if (selectedFilters?.centers?.length > 0) {
            payload = { ...payload, center: selectedFilters.centers?.map((center: any) => center.value) }
        }
        if (selectedFilters?.states?.length > 0) {
            payload = { ...payload, state: selectedFilters.states?.map((state: any) => state.value) }
        }
        if (selectedFilters?.districts?.length > 0) {
            payload = { ...payload, city: selectedFilters.districts?.map((district: any) => district.value) }
        }
        if (selectedFilters?.zones?.length > 0) {
            payload = { ...payload, zone: selectedFilters.zones?.map((zone: any) => zone.value) }
        }

        if (selectedFilters?.attendance?.value !== undefined) {
            payload = { ...payload, operator_attendance: selectedFilters.attendance?.value }
        }
        // else {
        //     payload = { ...payload, operator_attendance: false }
        // }

        setLoading(true)
        await ClientService.getAttendanceReport(selectValue, pageSize, pageNumber, payload)
            .then((res) => {
                if (res.status === 200) {
                    setStudentsData(res.data?.data?.attendance || []);
                    setTotolCount(res.data?.data?.count || 0);
                    setTotalUserCount(res.data?.data?.total_count || 0);
                    setPresentCount(res.data?.data?.present_count || 0);
                    setTobeSynced(res.data?.data?.tobesynced_count || 0);
                }
            })
            .catch((err) => {
                toast.error(err.response?.data || "An error occurred");
            });
        setLoading(false)
    };

    const downloadAttendanceCSV = async (attendanceStatus: boolean) => {
        if (!selectValue) {
            toast.error("Please select a shift first");
            return;
        }

        const isPresent = attendanceStatus;
        if (isPresent) {
            setDownloadingPresent(true);
        } else {
            setDownloadingAbsent(true);
        }

        try {

            let payload: any = { operator_attendance: attendanceStatus };


            if (selectedFilters?.centers?.length > 0) {
                payload = { ...payload, center: selectedFilters.centers?.map((center: any) => center.value) }
            }
            if (selectedFilters?.states?.length > 0) {
                payload = { ...payload, state: selectedFilters.states?.map((state: any) => state.value) }
            }
            if (selectedFilters?.districts?.length > 0) {
                payload = { ...payload, city: selectedFilters.districts?.map((district: any) => district.value) }
            }
            if (selectedFilters?.zones?.length > 0) {
                payload = { ...payload, zone: selectedFilters.zones?.map((zone: any) => zone.value) }
            }

            if (selectedFilters?.attendance?.value !== undefined) {
                payload = { ...payload, operator_attendance: isPresent }
            }
            // if (selectedCenters?.length > 0) {
            //     payload = { ...payload, center: selectedCenters?.map((center: any) => center.value) }
            // }
            // if (selectedStates?.length > 0) {
            //     payload = { ...payload, state: selectedStates?.map((state: any) => state.value) }
            // }
            // if (selectedDistricts?.length > 0) {
            //     payload = { ...payload, city: selectedDistricts?.map((district: any) => district.value) }
            // }
            // if (selectedZones?.length > 0) {
            //     payload = { ...payload, zone: selectedZones?.map((zone: any) => zone.value) }
            // }

            const response = await ClientService.getAttendanceReport(selectValue, 1000000, 1, payload);

            if (response.status === 200) {
                const attendanceData = response.data?.data?.attendance || [];

                if (attendanceData.length === 0) {
                    toast.error(`No ${isPresent ? 'present' : 'absent'} candidates found`);
                    return;
                }

                // Convert data to CSV format
                const csvHeaders = ['Sr. No', 'Name', 'Roll No', 'Venue Id', 'Venue Name', 'Present', 'Synced', 'Operator Id'];
                const csvRows = attendanceData.map((data: any, index: number) => [
                    index + 1,
                    data?.name || "--",
                    data?.rollNo || "--",
                    data?.allocatedCenterId || "--",
                    data?.centerPreference || "--",
                    data?.other?.operator_attendance?.value ? "Present" : "Absent",
                    data?.other?.mhcet_sync ? "Synced" : "Not-Synced",
                    data?.other?.operator_attendance?.operatorId?.userName || "--"
                ]);

                // Create CSV content
                const csvContent = [
                    csvHeaders.join(','),
                    ...csvRows.map((row: any[]) => row.map((cell: any) => `"${cell}"`).join(','))
                ].join('\n');

                // Generate filename with timestamp
                const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
                const statusText = isPresent ? 'Present' : 'Absent';
                const fileName = `Attendance_Report_${statusText}_${timestamp}`;

                saveAsCSV(csvContent, fileName);
                toast.success(`${statusText} candidates CSV downloaded successfully`);
            }
        } catch (err: any) {
            toast.error(err.response?.data || "An error occurred while downloading CSV");
        } finally {
            if (isPresent) {
                setDownloadingPresent(false);
            } else {
                setDownloadingAbsent(false);
            }
        }
    };


    useEffect(() => {
        if (selectValue) {
            getExceptionReport();
        }
    }, [pageNumber, pageSize, selectedFilters]);


    useEffect(() => {
        getAllShift();
    }, []);

    return (
        <>
            <Row className="mt-5 text-left">
                <Col md={4}>
                    <h4 className="fw-bold">Attendance Report</h4>
                </Col>
                <Col md={4}></Col>
                <Col md={4}>
                    <Form.Label className="text-muted fw-bold">
                        Select Shift
                    </Form.Label>
                    <Select
                        options={shifts}
                        placeholder="Select Shifts"
                        onChange={(e: any) => setSelectValue(e?.value)}
                        isClearable
                        value={selectValue ? shifts.find((shift: any) => shift.value === selectValue.value) : null}
                    />
                </Col>
            </Row>

            <FiltersComponent
                selectedShift={selectValue}
                onFiltersChange={handleFiltersChange}
                showAttendanceFilters={true}
            />

            <Row>
                <Col>
                    <div className="mt-2">
                        <Button
                            variant="success"
                            size="sm"
                            className="me-2"
                            onClick={() => downloadAttendanceCSV(true)}
                            disabled={downloadingPresent || !selectValue || selectedFilters?.centers?.length === 0}
                        >
                            {downloadingPresent ? 'Downloading...' : 'Download Present CSV'}
                        </Button>
                        <Button
                            variant="danger"
                            size="sm"
                            onClick={() => downloadAttendanceCSV(false)}
                            disabled={downloadingAbsent || !selectValue || selectedFilters?.centers?.length === 0}
                        >
                            {downloadingAbsent ? 'Downloading...' : 'Download Absent CSV'}
                        </Button>
                    </div>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col md={3}>
                    <UsersCard
                        reactIcon={<FontAwesomeIcon icon={faUser} className="fs-1 text-muted" />}
                        header={"Scheduled Candidates"}
                        statsValue={totalUserCount || 0}
                        style={{ backgroundColor: "#11009E", color: "white" }}
                    />
                </Col>
                <Col md={3}>
                    <UsersCard
                        reactIcon={<FontAwesomeIcon icon={faUser} className="fs-1 text-muted" />}
                        header={"Present Candidates"}
                        statsValue={presentCount || 0}
                        style={{ backgroundColor: "#004A2F", color: "white" }}
                    />
                </Col>
                <Col md={3}>
                    <UsersCard
                        reactIcon={<FontAwesomeIcon icon={faUser} className="fs-1 text-muted" />}
                        header={"Absent Candidates"}
                        statsValue={totalUserCount - presentCount || 0}
                        style={{ backgroundColor: "#8174A0", color: "white" }}
                    />
                </Col>

                <Col md={3}>
                    <UsersCard
                        reactIcon={<FontAwesomeIcon icon={faUser} className="fs-1 text-muted" />}
                        header={"Yet to be Synced"}
                        statsValue={tobeSynced || 0}
                        style={{ backgroundColor: "#cf6b00ff", color: "white" }}
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <Card
                        className="mt-3"
                        style={{
                            backgroundColor: "#f9f9f9",
                            borderRadius: "12px",
                            border: "none",
                        }}
                    >
                        <Card.Body>
                            <div className="d-flex align-items-center  justify-content-end ">
                                <FontAwesomeIcon icon={faRefresh} className='m-2 cursor-pointer' onClick={getExceptionReport} />
                            </div>
                            <Table striped hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: 14 }}>Sr. No</th>
                                        <th style={{ fontSize: 14 }}>Name</th>
                                        <th style={{ fontSize: 14 }}>Roll No</th>
                                        <th style={{ fontSize: 14 }}>Venue Id</th>
                                        <th style={{ fontSize: 14 }}>Venue Name</th>
                                        <th style={{ fontSize: 14 }}>Operator Name</th>
                                        <th style={{ fontSize: 14 }}>Present</th>
                                        <th style={{ fontSize: 14 }}>Synced</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        loading ? (
                                            <tr>
                                                <td colSpan={7} className="text-center">Loading...</td>
                                            </tr>
                                        ) : studentsData && studentsData.length > 0 ? (
                                            studentsData.map((data: any, index: number) => {
                                                return (
                                                    <tr>
                                                        <td style={{ fontSize: 12 }}>{pageNumber === 1 ? index + 1 : (pageNumber - 1) * pageSize + index + 1}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.name || "--"}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.rollNo || "--"}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.centerPreference || "--"}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.allocatedCenterId || "--"}</td>
                                                        <td style={{ fontSize: 12 }}>
                                                            <div className='cursor-pointer text-decoration-underline text-primary' onClick={() => { setSelectedOperator(data?.other?.operator_attendance?.profileInvId?._id || ''); }}>
                                                                {/* <div className='cursor-pointer text-decoration-underline text-primary'> */}
                                                                {data?.other?.operator_attendance?.profileInvId?.name || "--"}
                                                            </div>
                                                            <div>
                                                                {data?.other?.operator_attendance?.profileInvId?.lastSyncedOn ? moment(data?.other?.operator_attendance?.profileInvId?.lastSyncedOn).format("DD-MM-YY, hh:mm a") : "--"}
                                                            </div>
                                                        </td>
                                                        <td style={{ fontSize: 12 }}>{data?.other?.operator_attendance?.value ? <span className='text-success'>Present</span> : <span className='text-danger'>Absent</span>}</td>
                                                        <td style={{ fontSize: 12 }}>{data?.other?.mhcet_sync ? <span className='text-success'>Synced</span> : <span className='text-danger'>Not-Synced</span>}</td>
                                                    </tr>
                                                )
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={15} className="text-center">No data available</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <TablePaginationComponent
                        currentPage={pageNumber}
                        itemsCount={totalCount}
                        itemsPerPage={pageSize}
                        setItemsPerPage={(e: any) => setPageSize(e)}
                        setCurrentPage={setPageNumber}
                    />
                </Col>
            </Row>

            <InvigilatorModal
                show={selectedOperator}
                handleClose={() => setSelectedOperator('')}
            />

        </>
    )
}
